import {FETCH_SCHEDULE_DATE} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_SCHEDULE_DATE:
            return action.payload;
        default:
            return state;
    }
};